import api from '../../../lib/Api'
import * as types from '../../actionTypes'

const intitialState = {
  skus: new Map(),
  isLoading: false,
  roles: [],
}

export const fetchingSkus = () => ({
  type: types.FETCHING_SKUS,
})

export const fetchingSkusError = () => {
  return {
    type: types.FETCHING_SKUS_ERROR,
    error: 'Error fetching Skus',
  }
}

export const fetchingSkusSuccess = skus => {
  return {
    type: types.FETCHING_SKUS_SUCCESS,
    skus: skus,
  }
}

export const fetchingRoles = () => ({
  type: types.FETCHING_ROLES,
})

export const fetchingRolesError = () => {
  return {
    type: types.FETCHING_ROLES_ERROR,
    error: 'Error fetching Roles',
  }
}

export const fetchingRolesSuccess = roles => {
  return {
    type: types.FETCHING_ROLES_SUCCESS,
    roles: roles,
  }
}

export const fetchAndHandleSkus = () => {
  return async function(dispatch) {
    dispatch(fetchingSkus())

    try {
      const response = await api.get('/product')
      dispatch(fetchingSkusSuccess(response.data))
    } catch (error) {
      dispatch(fetchingSkusError(error))
    }
  }
}

export const fetchAndHandleRoles = () => {
  return async function(dispatch) {
    dispatch(fetchingRoles())

    try {
      const response = await api.get('/admin/roles')
      dispatch(fetchingRolesSuccess(response.data))
    } catch (error) {
      dispatch(fetchingRolesError(error))
    }
  }
}

export default (state = intitialState, action) => {
  switch (action.type) {
    case types.FETCHING_SKUS:
      return {
        ...state,
        isLoading: true,
      }
    case types.FETCHING_SKUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        skus: new Map(action.skus.map(i => [i.sku, i.details])),
      }
    case types.FETCHING_SKUS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    case types.FETCHING_ROLES:
      return {
        ...state,
        isLoading: true,
      }
    case types.FETCHING_ROLES_SUCCESS:
      const formattedRoles = action.roles.map(role => {
        role.value = role.roleId
        role.label = role.roleName
        return role
      })
      return {
        ...state,
        isLoading: false,
        roles: formattedRoles,
      }
    case types.FETCHING_ROLES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/refData/refData.js